import { useEffect, useState } from 'react'

export type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>('xs')

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth

      if (width < 640) return setScreenSize('xs')
      if (width < 768) return setScreenSize('sm')
      if (width < 1024) return setScreenSize('md')
      if (width < 1280) return setScreenSize('lg')
      if (width < 1536) return setScreenSize('xl')
      setScreenSize('2xl')
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return screenSize
}

export const compareScreenSizes = (a: ScreenSize, b: ScreenSize) => {
  const sizeOrder: ScreenSize[] = ['xs', 'sm', 'md', 'lg', 'xl', '2xl']
  return sizeOrder.indexOf(a) - sizeOrder.indexOf(b)
}
